module.exports = __webpack_public_path__ + "media/images/user-lock2-3cd3d836.png";